import React from 'react';
import styled from 'styled-components';

function DetailPageFooter() {
  return (
    <Container>
      <img
        src="/assets/images/logo/zipgoai_logo_gray.svg"
        alt="logo"
        width={61}
      />
      <Content>
        본 서비스에서 제공하는 경매물건 정보는 대법원 경매자료 및 기타
        공부서류를 기초로 제공되며, 입력 착오 또는 내용 변경 등으로 실제와 다를
        수 있습니다. 입찰 참여 전 반드시 해당 법원에 비치된 매각물건명세서,
        현황조사서 등 관련 자료를 직접 열람하시어 정보를 재확인하시기 바랍니다.
        본 정보는 참고용으로 제공되며, 이를 기반으로 한 입찰 등 행위로 발생하는
        손해에 대해 당사는 법적 책임을 지지 않습니다.
      </Content>
    </Container>
  );
}

export default DetailPageFooter;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 40px;
  padding-right: 16px;
  padding-bottom: 120px;
  padding-left: 16px;
`;

const Content = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-style: Medium;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 145%;
  letter-spacing: -2%;
  vertical-align: middle;
  color: #b0b7bf;
`;
